import styled from 'styled-components';
import Link from 'next/link';

import { t } from 'localization/utils/t';
import { APP_DOWNLOAD_LINK_APP_PAGE } from '../enums/appLandingPageEnums';

const TP = 'appLanding.components.AndroidCta';

export const AndroidCta = ({ link }: { link?: string }) => (
  <Link
    href={link || APP_DOWNLOAD_LINK_APP_PAGE}
    aria-label={t(`${TP}.downloadTheGoatApp`, 'Download the GOAT App')}
  >
    <AndroidCta.Img
      data-qa="android_download_app"
      src="https://cms-cdn.goat.com/3000/a215c3373913-160a-0f11-634c-09f88527.png"
      alt={t(`${TP}.googlePlayCta`, 'Google Play CTA')}
    />
  </Link>
);

AndroidCta.Img = styled.img`
  height: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    height: 40px;
  }
`;
